import { Stack } from '@mui/material';
import { Job, StopType } from '../../common/apis/dtos';
import { ItemDetailsSummary, ItemDetailsType } from './ItemDetailsSummary';
import { Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

declare interface ItemDetailsProps {
  shipment: Job;
  isMobileScreen: boolean;
}

export const ItemDetails = ({ shipment, isMobileScreen }: ItemDetailsProps) => {
  const translate = useTranslation();
  const sortedStops = [...shipment.stops]?.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
  const stopComponents = sortedStops.map((stop, index) => (
    <ItemDetailsSummary
      key={index}
      isMobileScreen={isMobileScreen}
      itemDetailsType={stop.stopType === StopType.Pick ? ItemDetailsType.PickUp : ItemDetailsType.DeliverTo}
      stopInfo={stop}
    />
  ));

  return (
    <Stack
      spacing={3}
      padding={1}
      className={isMobileScreen ? 'mobile' : ''}
      data-testid="item-details-tab"
    >
      <Typography variant="h2">{translate('Item Details')}</Typography>
      {stopComponents}
    </Stack>
  );
};
